import { render, staticRenderFns } from "./skeletonCard.vue?vue&type=template&id=e551b006&lang=pug"
import script from "./skeletonCard.vue?vue&type=script&lang=js"
export * from "./skeletonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports